import type { ReactNode } from 'react';
import { ROUTES } from '../../../const/routes';
import helpSvg from '../../../images/help.svg';
import stamp from '../../../images/stamp.svg';
import BasicTransition from '../../BasicTransition';
import {
	ApprovalStamp,
	BlueCircle,
	Container,
	FormContainer,
	FormWrapper,
	GreenCircle,
	HelpLink,
	LandingPageImage,
	YellowCircle,
} from './styles';

interface Props {
	children: ReactNode;
	imageUrl?: string;
	imageDescription?: string;
	hideHelp?: boolean;
}

export const AuthLayout = ({ children, imageDescription, imageUrl, hideHelp = false }: Props) => (
	<Container>
		<GreenCircle />
		<YellowCircle />
		<BlueCircle />
		<BasicTransition>
			<FormWrapper>
				{imageUrl && <LandingPageImage src={imageUrl} alt={imageDescription} />}
				<FormContainer>{children}</FormContainer>
			</FormWrapper>
		</BasicTransition>
		<ApprovalStamp src={stamp} alt="Potvrzeno by Evidia" />
		{!hideHelp && (
			<HelpLink to={ROUTES.OUT_APP.CONTACT}>
				<img src={helpSvg} width={38} height={38} alt="Pomoc ikonka" />
				<span>
					Potřebujete
					<br />
					pomoct?
				</span>
			</HelpLink>
		)}
	</Container>
);
